<template>
  <section v-if="!this.loaded">
    <div v-if="lists" class="rounded border bg-white info-panel custom-table">
      <div class="table-responsive">
        <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 text-gray-800 mb-0" style="white-space: nowrap!important;">
          <thead>
          <tr class="fw-bold fs-8 text-gray-400">
            <th class="w-70px">ID</th>
            <th>Наименование</th>
            <th class="w-50px">Статус</th>
            <th class="w-100px">Создан</th>
            <th class="text-center w-70px">Действие</th>
          </tr>
          </thead>
          <tbody v-if="lists.length >= 0">
          <tr class="align-middle">
            <td colspan="8" class="text-center">
              <div @click="openAgreement(null)" class="rounded border border-dashed pt-6 pb-6 cursor-pointer text-gray-400 border-gray-300 text-hover-primary border-hover-primary" style="border-width: 1px">Добавить</div>
            </td>
          </tr>
          <tr v-for="(item, key) in lists" :key="key" class="align-middle">
            <td v-html="item.id"></td>
            <td style="max-width: 150px !important; overflow: hidden; white-space: nowrap;text-overflow: ellipsis;" v-html="item.title"></td>
            <td>{{ item.status === 1 ? 'Активный' : 'Неактивный' }}</td>
            <td v-html="item.created"></td>
            <td class="text-center">
              <i @click="openAgreementConfirm(item.id)" class="ki-outline ki-profile-user fs-3 text-primary cursor-pointer d-inline-block" style="margin-top: 1px"></i>
              <i @click="openAgreement(item)" class="ki-outline ki-notepad-edit fs-3 text-warning cursor-pointer ms-3 d-inline-block" style="margin-top: 1px"></i>
              <i @click="deleteAgreement(key, item.id)" class="ki-outline ki-cross-square fs-3 text-danger cursor-pointer ms-3 d-inline-block" style="margin-top: 1px"></i>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-if="lists.length <= 0" class="p-10 text-center text-gray-600">
          Нет записи
        </div>
      </div>
    </div>
  </section>
  <template v-else>
    <loader-full/>
  </template>
  <agreement-modal v-if="showAgreement" @close="closeAgreementModal" :agreement-data="agreementData" />
  <agreement-confirmed-modal v-if="users && showConfirmed" @close="closeConfirmedModal" :users-list="this.users" :agreement-id="confirmedId" />
</template>

<script>
// Modal
import AgreementConfirmedModal from '@/views/Admin/Agreement/AgreementConfirmedModal'
import AgreementModal          from '@/views/Admin/Agreement/AgreementModal'
// Other
import LoaderFull     from '@/components/Main/LoaderFull'
import axios          from 'axios'

export default {
  name: 'Agreement',
  components: {AgreementModal, AgreementConfirmedModal: AgreementConfirmedModal, LoaderFull},
  data() {
    return {
      loaded: false,
      lists:  null,
      users:  null,
      confirmedId: null,
      agreementData: null,
      showConfirmed: false,
      showAgreement: false,
    }
  },
  mounted() {
    this.getAgreement().then(() => {this.getUsers()})
  },
  methods: {
    closeAgreementModal(val) {
      bootstrap.Modal.getInstance(document.getElementById('AgreementModal')).hide();
      this.showAgreement = false
      if (val.update) this.getAgreement()
    },
    closeConfirmedModal(val) {
      bootstrap.Modal.getInstance(document.getElementById('AgreementConfirmedModal')).hide();
      this.showConfirmed = false
      if (val.update) this.getAgreement()
    },
    openAgreement(data) {
      this.showAgreement = true
      if (data === null) data = {id: null, title: null, description: null, document: null, status: 1}
      this.agreementData = structuredClone(data)
      setTimeout(() => new bootstrap.Modal('#AgreementModal', {}).show(), 10)
    },
    openAgreementConfirm(changeId) {
      this.showConfirmed = true
      this.confirmedId = changeId
      setTimeout(() => {new bootstrap.Modal('#AgreementConfirmedModal', {}).show()}, 10)
    },
    async getAgreement () {
      this.loaded = true
      return await axios.get('/api/admin/agreement/admin/list')
          .then(res => {
            this.lists = res.data
          })
          .catch(err => {console.log(err)})
          .finally(() => {this.loaded = false})
    },
    getUsers() {
      axios.get('api/admin/agreement/admin/users-list')
          .then(res => {this.users = res.data})
          .catch(err => {console.log(res.message)})
    },
    deleteAgreement(key, id) {
      if (confirm(`Удалить ${this.lists[key].title}?`)) {
        this.loaded = true
        axios.delete('api/admin/agreement/admin/delete/'+id)
            .then(() => {this.lists.splice(key, 1)})
            .catch(err => {console.log(err)})
            .finally(() => {this.loaded = false})
      }
    },
    modalHidden() {
      const myModalEl = document.getElementById('agreementModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      if (modal) modal.hide()
    },
  }
}
</script>

<style scoped>

</style>